import { render, staticRenderFns } from "./wayverPage.vue?vue&type=template&id=1b00e6d6&"
import script from "./wayverPage.vue?vue&type=script&lang=ts&"
export * from "./wayverPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports